import { useEffect, useMemo, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBox, MiCheckbox } from "@miplatform/components";
import { capitalize, deepEqual, isEmpty } from "@miplatform/utils";
import { Footer } from "@mibuildweb/components";
import { GridLegacy, Typography } from "@mui/material";

const OPTIONS = {
  VISIBLE: "visible",
  REQUIRED: "required",
};

export function InputOptions({ inputOptions = [], onUpdate = () => null }) {
  const [formData, setFormData] = useState(inputOptions);

  const isDirty = useMemo(() => !deepEqual(inputOptions, formData), [formData]);

  const reset = () => {
    setFormData(inputOptions);
  };

  useEffect(() => {
    reset();
  }, [inputOptions]);

  const { classes } = useStyles();

  if (isEmpty(inputOptions)) {
    return <Typography>No data...</Typography>;
  }

  const onCheck = (target, field) => () => {
    if (field === OPTIONS.VISIBLE && target.required) {
      setFormData((prev) =>
        prev.map((e) =>
          e.displayName === target.displayName
            ? { ...e, [OPTIONS.VISIBLE]: false, [OPTIONS.REQUIRED]: false }
            : e
        )
      );
      return;
    }

    setFormData((prev) =>
      prev.map((e) =>
        e.displayName === target.displayName ? { ...e, [field]: !e[field] } : e
      )
    );
  };

  const onSave = () => {
    onUpdate(formData);
  };

  return (
    <>
      <MiBox>
        <GridLegacy container>
          <GridLegacy item xs={3} />
          <GridLegacy item xs={3}>
            <Typography>{capitalize(OPTIONS.VISIBLE)}</Typography>
          </GridLegacy>
          <GridLegacy item xs={3}>
            <Typography>{capitalize(OPTIONS.REQUIRED)}</Typography>
          </GridLegacy>
        </GridLegacy>
        {formData.map((e) => (
          <GridLegacy container key={e.displayName}>
            <GridLegacy item xs={3} className={classes.displayName}>
              <Typography> {e.displayName}</Typography>
            </GridLegacy>
            <GridLegacy item xs={3}>
              <MiCheckbox
                value={e.visible}
                handleChange={onCheck(e, OPTIONS.VISIBLE)}
              />
            </GridLegacy>
            <GridLegacy item xs={3}>
              <MiCheckbox
                value={e.required}
                handleChange={onCheck(e, OPTIONS.REQUIRED)}
                disabled={!e.visible}
              />
            </GridLegacy>
          </GridLegacy>
        ))}
      </MiBox>
      <Footer
        show={isDirty}
        handleCancelClick={reset}
        handleSaveClick={onSave}
      />
    </>
  );
}

const useStyles = makeStyles()(() => ({
  displayName: {
    display: "flex",
    alignItems: "center",
  },
}));
